var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feedback-form" },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.feedback-form",
              modifiers: { "feedback-form": true },
            },
          ],
          staticClass: "trigger",
          attrs: { id: "feedback-trigger" },
        },
        [_vm._v("\n        Feedback geben\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "feedback-form",
          attrs: {
            id: "feedback-form",
            title: "Feedback zum Community-Portal",
            "ok-variant": "success",
            "ok-title": "Absenden",
            "cancel-title": "Abbrechen",
          },
          on: { ok: _vm.submitFeedback, show: _vm.init },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _vm.state === _vm.STATES.USER_INPUT
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.submitFeedback($event)
                            },
                          },
                        },
                        [_vm._v("\n                Absenden\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state !== _vm.STATES.SUBMITTING
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "" },
                          on: {
                            click: function ($event) {
                              return cancel()
                            },
                          },
                        },
                        [_vm._v("\n                Schließen\n            ")]
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _vm.state === _vm.STATES.SUBMIT_FAILED
            ? _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [
                  _c("p", [
                    _vm._v(
                      "Dein Feedback konnte leider nicht gesendet werden."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Sende uns bitte eine E-Mail an "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "mailto:kommunikation-studienfoerderung@fes.de",
                        },
                      },
                      [_vm._v("kommunikation-studienfoerderung@fes.de")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.state === _vm.STATES.USER_INPUT ||
          _vm.state === _vm.STATES.SUBMIT_FAILED
            ? _c(
                "div",
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Was ist schief gelaufen?",
                            "label-for": "message",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            staticClass: "message-input",
                            attrs: { name: "message" },
                            model: {
                              value: _vm.text,
                              callback: function ($$v) {
                                _vm.text = $$v
                              },
                              expression: "text",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Datei (Screenshot) anhängen",
                            "label-for": "screenshot",
                          },
                        },
                        [
                          _c("b-form-file", {
                            attrs: {
                              placeholder: "Wählen Sie eine Datei ...",
                              "drop-placeholder": "Datei hier ablegen ...",
                            },
                            model: {
                              value: _vm.screenshot,
                              callback: function ($$v) {
                                _vm.screenshot = $$v
                              },
                              expression: "screenshot",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.askForPersonalInfo
                        ? _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Dein Name",
                                "label-for": "name",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { type: "text", name: "name" },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.askForPersonalInfo
                        ? _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Deine E-Mail-Adresse",
                                "label-for": "name",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { type: "email", name: "email" },
                                model: {
                                  value: _vm.email,
                                  callback: function ($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Mit dem Absenden übermittelst du uns einige zusätzliche Daten, wie deine Browser-Version und Seiten-URL. Das hilft uns, dein Feedback nachzuvollziehen."
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.state === _vm.STATES.SUBMITTING
            ? _c("div", [_vm._v("\n            Sende Daten…\n        ")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state === _vm.STATES.SUBMIT_SUCCESSFUL
            ? _c(
                "div",
                {
                  staticClass: "alert alert-success",
                  attrs: { role: "alert" },
                },
                [
                  _vm._v(
                    "\n            Übermittlung erfolgreich. Vielen Dank für dein Feedback!\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }